import { Badge, Tooltip } from '@shopify/polaris';
import { useLookupStore } from '../../../context/useStore';
import { formatToCurrency } from '../functions';
import { labelFor, toneFor } from './approvalStatus';
import { normalizeApprovalLines } from './normalizeApprovalLines';

/*
  Document approval status as a badge, with the assignee abbreviation and a tooltip listing the allocation lines.
  lines: array or JSON string of approval lines (old or new shape).
*/
export default function ApprovalStatusBadge({ status, assigneeAfkorting, lines, size }) {
  const users = useLookupStore((state) => state.users);
  const purchasetypes = useLookupStore((state) => state.purchasetypes);
  const normalized = normalizeApprovalLines(lines);

  const badge = (
    <Badge tone={toneFor(status)} size={size}>
      {labelFor(status)}
      {assigneeAfkorting ? ` · ${assigneeAfkorting}` : ''}
    </Badge>
  );

  if (!normalized.length) return badge;

  return (
    <Tooltip
      content={
        <div style={{ minWidth: 280 }}>
          {normalized.map((line, index) => {
            const user = line.approverAfkorting || users.find((u) => u.GebruikerID === line.approverId)?.Afkorting || '?';
            const costType = line.costTypeName || purchasetypes.find((pt) => pt.BestellingTypeID === line.costTypeId)?.BestellingType;
            return (
              <div key={line.id ?? index} style={{ display: 'flex', gap: 8, justifyContent: 'space-between', padding: '2px 0' }}>
                <span>
                  <strong>{user}</strong> {costType ? `· ${costType}` : ''} {line.projectNumber ? `· 🚧 ${line.projectNumber}` : ''}
                </span>
                <span>
                  {formatToCurrency(line.amount)} · {labelFor(line.status)}
                  {line.rejectReason ? ` (${line.rejectReason})` : ''}
                </span>
              </div>
            );
          })}
        </div>
      }
    >
      {badge}
    </Tooltip>
  );
}
